import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import useScrollAnimation from "../hooks/useScrollAnimation";
import { useNavigate, Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import NewsletterForm from "../components/NewsletterForm";

function Home() {
    useScrollAnimation();
    const navigate = useNavigate();

    const images = [
        '/images/image1.png',
        '/images/image2.png',
        '/images/image3.png',
        '/images/image4.png'
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const fullText = "Gesingo Security Technology\nYour Security is Our Concern.";
    const [displayedText, setDisplayedText] = useState('');
    const [charIndex, setCharIndex] = useState(0);

    // Image slider (does NOT affect typewriter)
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex(prevIndex => (prevIndex + 1) % images.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [images.length]);

    // Typewriter logic
    useEffect(() => {
        if (charIndex < fullText.length) {
            const timeout = setTimeout(() => {
                setDisplayedText(prev => prev + fullText[charIndex]);
                setCharIndex(prev => prev + 1);
            }, 100);
            return () => clearTimeout(timeout);
        } else {
            const restart = setTimeout(() => {
                setDisplayedText('');
                setCharIndex(0);
            }, 2000);
            return () => clearTimeout(restart);
        }
    }, [charIndex, fullText]);

    return (
        <div className="font-poppins page-float route-enter">
            <Navbar />

            {/* Hero Section */}
            <section id="home" className="relative h-[90vh] md:h-screen text-white fade-in overflow-hidden">
                {/* Background Image Slider */}
                <div className="absolute inset-0 z-0">
                    {images.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`Security Technology ${index + 1}`}
                            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${index === currentImageIndex ? "opacity-100" : "opacity-0"}`}
                        />
                    ))}
                </div>

                {/* Dark overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/50 to-black/30 z-10" />

                {/* Hero Content */}
                <div className="relative z-20 max-w-6xl mx-auto h-full px-6 flex items-center">
                    <div className="max-w-2xl">
                        <span className="inline-block text-xs md:text-sm font-semibold tracking-wide bg-white/10 backdrop-blur rounded-full px-4 py-2 border border-white/20">Your Security and  Tech Giant</span>
                        <h1 className="mt-4 text-4xl md:text-6xl font-extrabold leading-tight whitespace-pre-line">
                            {displayedText.split("\n")[0] || "Gesingo Security Technology"}
                        </h1>
                        <p className="mt-3 md:mt-4 text-brand-50 md:text-lg">
                            {displayedText.split("\n")[1] || "Your Security Is Our Concern."}
                        </p>
                        <div className="mt-6 flex flex-wrap gap-4">
                            <button onClick={() => {
                                const el = document.getElementById('services');
                                if (el) el.scrollIntoView({ behavior: 'smooth' });
                            }} className="inline-flex items-center px-6 py-3 rounded-full bg-brand-accent text-white font-semibold hover:bg-brand-400 transition">
                                Discover More
                            </button>
                            <button onClick={() => navigate('/services')} className="inline-flex items-center px-6 py-3 rounded-full border border-white/60 text-white/90 hover:bg-white/10 transition">
                                See All Services
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Trust/Benefit strip */}
            <section className="bg-brand-100/70">
                <div className="max-w-6xl mx-auto px-6 py-8 grid md:grid-cols-3 gap-6 items-center">
                    <div className="flex items-center gap-4">
                        <div className="flex -space-x-2">
                            <span className="w-8 h-8 rounded-full bg-brand-accent border border-white" />
                            <span className="w-8 h-8 rounded-full bg-brand-300 border border-white" />
                            <span className="w-8 h-8 rounded-full bg-brand-600 border border-white" />
                        </div>
                        <p className="font-semibold text-brand-900">100+ Clients with Positive Reviews</p>
                    </div>
                    <div className="mx-auto">
                        <div className="w-20 h-20 rounded-full bg-white grid place-items-center shadow border border-brand-200">
                            <span className="text-sm font-bold text-brand-700">Trusted</span>
                        </div>
                    </div>
                    <div className="flex items-center justify-between md:justify-end gap-4">
                        <p className="font-semibold text-brand-900">Service Beyond Expectation</p>
                        {/*<div className="w-20 h-12 rounded-lg overflow-hidden bg-white shadow ring-1 ring-brand-200 grid place-items-center text-brand-700 text-xs"></div>*/}
                    </div>
                </div>
            </section>


            {/* Services */}
            <section id="services" className="py-20 bg-white">
                <div className="max-w-6xl mx-auto px-6">
                    {/*<div className="flex items-end justify-between mb-8">*/}
                    {/*    <div>*/}
                    {/*        <p className="text-xs font-semibold tracking-wider text-green-600 uppercase">Our Services</p>*/}
                    {/*        <h2 className="text-3xl md:text-4xl font-extrabold text-green-950 leading-snug">We Offer Eco & Agriculture Services</h2>*/}
                    {/*    </div>*/}
                    {/*    /!* Optional stub controls *!/*/}
                    {/*    <div className="hidden md:flex items-center gap-2">*/}
                    {/*        <button className="w-9 h-9 rounded-full bg-green-100 text-green-800 grid place-items-center">‹</button>*/}
                    {/*        <button className="w-9 h-9 rounded-full bg-green-100 text-green-800 grid place-items-center">›</button>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">

                        {/* CCTV Installation */}
                        <article className="group rounded-2xl overflow-hidden bg-brand-800 text-white border border-brand-700 shadow hover:shadow-lg transition">
                            <div className="h-44 w-full bg-brand-200/20">
                                <img src="/images/cctv_installation.png" alt="CCCTV Installation" className="w-full h-full object-cover" loading="lazy" decoding="async" />
                            </div>
                            <div className="p-6">
                                <span className="inline-block text-[11px] px-2 py-1 rounded-full bg-brand-700/70 border border-brand-500 mb-2">CCTV Installation</span>
                                <h3 className="text-xl font-semibold">CCTV Installation</h3>
                                <p className="mt-2 text-brand-100/90 text-sm">High-definition surveillance systems for 24/7 monitoring of your premises.</p>
                            </div>
                        </article>

                        {/* Electric Fencing */}
                        <article className="group rounded-2xl overflow-hidden bg-brand-800 text-white border border-brand-700 shadow hover:shadow-lg transition">
                            <div className="h-44 w-full bg-brand-200/20">
                                <img src="/images/electric_fence.png" alt="Electric Fencing" className="w-full h-full object-cover" loading="lazy" decoding="async" />
                            </div>
                            <div className="p-6">
                                <span className="inline-block text-[11px] px-2 py-1 rounded-full bg-brand-700/70 border border-brand-500 mb-2">Electric Fencing</span>
                                <h3 className="text-xl font-semibold">Electric Fencing</h3>
                                <p className="mt-2 text-brand-100/90 text-sm">High-voltage perimeter security solutions designed to deter and detect intruders effectively.</p>
                            </div>
                        </article>

                        {/* Skills Training */}
                        <article className="group rounded-2xl overflow-hidden bg-brand-800 text-white border border-brand-700 shadow hover:shadow-lg transition">
                            <div className="h-44 w-full bg-brand-200/20">
                                <img src="/images/training.png" alt="Skills Training" className="w-full h-full object-cover" loading="lazy" decoding="async" />
                            </div>
                            <div className="p-6">
                                <span className="inline-block text-[11px] px-2 py-1 rounded-full bg-brand-700/70 border border-brand-500 mb-2">Skills Training</span>
                                <h3 className="text-xl font-semibold">Skills Training</h3>
                                <p className="mt-2 text-brand-100/90 text-sm">Professional technical training in security system installation, maintenance, and operation.</p>
                            </div>
                        </article>




                    </div>
                </div>
            </section>

            {/* Team/Staff Section */}
            <section className="py-20 bg-brand-50/50">
                <div className="max-w-6xl mx-auto px-6 text-center">
                    <h2 className="text-3xl md:text-4xl font-extrabold text-brand-950 mb-12">Meet Our Team</h2>
                    <div className="grid sm:grid-cols-3 gap-12">
                        {/* CEO */}
                        <div className="flex flex-col items-center">
                            <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-white shadow-lg mb-4 bg-brand-200">
                                <img src="/images/ceo.jpeg" alt="CEO" className="w-full h-full object-cover" />
                            </div>
                            <h3 className="text-xl font-bold text-brand-900">CEO</h3>
                            <p className="text-gray-600 text-sm mt-2">Visionary leader driving innovation and excellence in security technology.</p>
                        </div>

                        {/* Technician */}
                        <div className="flex flex-col items-center">
                            <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-white shadow-lg mb-4 bg-brand-200">
                                <img src="/images/technician.png" alt="Technician" className="w-full h-full object-cover" />
                            </div>
                            <h3 className="text-xl font-bold text-brand-900">Technician</h3>
                            <p className="text-gray-600 text-sm mt-2">Expert in high-precision installations and technical security systems.</p>
                        </div>

                        {/* Administrator */}
                        <div className="flex flex-col items-center">
                            <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-white shadow-lg mb-4 bg-brand-200">
                                <img src="/images/Administrator.png" alt="Administrator" className="w-full h-full object-cover" />
                            </div>
                            <h3 className="text-xl font-bold text-brand-900">Administrator</h3>
                            <p className="text-gray-600 text-sm mt-2">Ensuring seamless operations and exceptional customer service delivery.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Projects Showcase Section */}
            <section className="py-20 bg-white">
                <div className="max-w-6xl mx-auto px-6">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl md:text-4xl font-extrabold text-brand-950 mb-4">Our Recent Works</h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">Explore some of our successfully completed security technology projects.</p>
                    </div>
                    
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {/* Project 1 */}
                        <Link to="/works/work1" className="group bg-brand-50 rounded-2xl overflow-hidden border border-brand-100 shadow-sm hover:shadow-md transition">
                            <div className="aspect-video w-full overflow-hidden bg-brand-200">
                                <img src="/images/work1.png" alt="CCTV Installation Project" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                            </div>
                            <div className="p-5">
                                <h3 className="font-bold text-brand-900 text-lg">CCTV Surveillance Hub</h3>
                                <p className="text-gray-600 text-sm mt-1">Full-scale monitoring system installed for a corporate facility.</p>
                            </div>
                        </Link>

                        {/* Project 2 */}
                        <Link to="/works/work2" className="group bg-brand-50 rounded-2xl overflow-hidden border border-brand-100 shadow-sm hover:shadow-md transition">
                            <div className="aspect-video w-full overflow-hidden bg-brand-200">
                                <img src="/images/electric8.png" alt="Electric Fencing Project" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                            </div>
                            <div className="p-5">
                                <h3 className="font-bold text-brand-900 text-lg">Perimeter Security</h3>
                                <p className="text-gray-600 text-sm mt-1">Electric fencing and automated gate system for a residential estate.</p>
                            </div>
                        </Link>

                        {/* Project 3 */}
                        <Link to="" className="group bg-brand-50 rounded-2xl overflow-hidden border border-brand-100 shadow-sm hover:shadow-md transition">
                            <div className="aspect-video w-full overflow-hidden bg-brand-200">
                                <img src="/images/gate1.png" alt="Gate Automation Project" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                            </div>
                            <div className="p-5">
                                <h3 className="font-bold text-brand-900 text-lg">Gate Automation</h3>
                                <p className="text-gray-600 text-sm mt-1">Smart and automated sliding gate system for enhanced home access.</p>
                            </div>
                        </Link>
                    </div>
                </div>
            </section>

            {/* Newsletter (moved to Home footer like other pages) */}
            <section className="bg-gradient-to-br from-brand-900 to-brand-800 text-white">
                <div className="max-w-6xl mx-auto px-6 py-12 grid md:grid-cols-[1fr_auto] gap-6 items-center">
                    <div>
                        <h3 className="text-2xl font-semibold mb-1">Our Newsletters</h3>
                        <p className="text-brand-100 max-w-xl">Subscribe to receive updates about our services and initiatives.</p>
                    </div>
                    <NewsletterForm />
                </div>
            </section>

            {/* Footer stripe (match other pages) with WhatsApp icon */}
            <section className="bg-brand-50">
                <div className="max-w-6xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8 bg-white rounded-2xl shadow-sm">
                    <div className="space-y-3">
                        <img src="/images/logo.png" alt="Gesingo Security Technology logo" className="h-12 w-12 object-contain rounded" />
                        <p className="text-gray-600 text-sm">
                            Providing advanced security technology solutions and expert technical services to safeguard your environment.
                        </p>
                    </div>
                    <div className="col-span-3 grid sm:grid-cols-2 gap-6 text-sm text-gray-700">
                        <div>
                            <div className="font-semibold mb-2">Navigation</div>
                            <ul className="space-y-2">
                                <li><Link to="/" className="hover:underline">Home</Link></li>
                                <li><Link to="/about" className="hover:underline">About</Link></li>
                                <li><Link to="/services" className="hover:underline">Services</Link></li>
                                <li><Link to="/contact" className="hover:underline">Contact</Link></li>
                            </ul>
                        </div>
                        <div>
                            <div className="font-semibold mb-2">Work Hours</div>
                            <ul className="space-y-2">
                                <li>7:30AM – 5:30PM, Mon–Sun</li>
                                <li className="text-gray-500">Closed on Fridays</li>
                            </ul>
                            <div className="mt-4 flex items-center gap-3">
                                <a href="tel:+233244844226">
                                    <button type="button" className="inline-flex px-4 py-2 rounded-full bg-brand-600 text-white hover:bg-brand-700">Call Us</button>
                                </a>
                                <a
                                  href="https://wa.me/233504869983"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  aria-label="WhatsApp"
                                  className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-brand-accent text-white hover:bg-brand-400 shadow"
                                >
                                  <FaWhatsapp className="text-lg" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <footer className="text-center text-gray-500 text-sm py-6">
                <p>© {new Date().getFullYear()} Gesingo Security Technology</p>
                <p className="mt-1">Designed by <a href="https://wa.me/233545038856" className="text-brand-600 hover:underline" target="_blank" rel="noopener noreferrer">WASS TECH SOLUTIONS</a></p>
            </footer>
        </div>
    );
}

export default Home;
